module.exports = __webpack_public_path__ + "media/spinner-ea3479aa.gif";